import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@material-ui/core'

export default function Spinner({ color, size }) {
  return (
    <CircularProgress color={color} size={size} />
  )
}

Spinner.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

Spinner.defaultProps = {
  color: 'primary',
  size: null,
}
